<template>
  <div class="reading-party">
      <div class="reading-main">
        <p class="tit clearfix">
            <span><a href="/">首页</a></span>
            <!-- <span class="arr-bold">&gt;</span> -->
            <!-- <span>亚商读书会</span> -->
            <span class="arr-bold">&gt;</span>
            <span class="font-blue">读书列表</span>
        </p>
        <div class="content">
           <div class="lead">
             <span class="logo fl"><img src="./reading-logo.png" alt=""></span>
            <p class="text">【亚商读书会】成立于2016年3月5日，是由亚商资本创办，亚商读书委员会主办，以重视企业家内在精神文化娱乐层面，缔造儒商情怀，非盈利性读书交流平台。读书会以爱读书，读好书，乐分享为前提，为企业家创造一个线上线下互通，交流无阻碍，教学相长的沟通机会。</p>
            <p class="text">初期会员由历程28年的亚商老友会，新沪商联合会大商学院，湖州象牛堂，交大安泰学院MBA、EMBA，实业家，企业家，投资人等近百位社会活跃人士组成。奠定了读书会商界，学界，投资界的高水准社交圈和读书平台。</p>
          </div>
          <div class="reding-list">
            <ul>
              <li v-for="(item, index) in readingList" :key="item.id">
                <a :href="`/readingDetail/${item.id}`">
                  <div class="reading-pic">
                    <img :src="item.imgUrl" alt="" width="100%">
                    <div class="mask-title"><span class="fl">{{item.title}}</span><span class="fr">{{item.time}}</span></div>
                  </div>
                  <div class="text">{{item.text}}</div>
                </a>
              </li>
            </ul>
            <!-- <p class="more"><span>查看更多 <img src="./slide-gray.png" alt=""></span></p> -->
          </div>
        </div>
      </div>
      <go-top></go-top>
  </div>
</template>

<script>
import goTop from "../../common/go-top.vue";
const dsh1 = require('./dsh1.png');
const dsh2 = require('./dsh2.png');
const dsh3 = require('./dsh3.png');
const dsh4 = require('./dsh4.png');
const dsh5 = require('./dsh5.jpg');
export default {
  name: 'ReadingParty',
  components: {
    goTop
  },
  data(){
    return {
      readingList: [
        {
          id: 0,
          title: '亚商读书会第一期',
          time: '2016.03.05',
          text: '我读一本书 足以慰风尘',
          imgUrl: dsh1
        },
        {
          id: 1,
          title: '亚商读书会第二期',
          time: '2016.04.08',
          text: '无竹则俗 无书则浮',
          imgUrl: dsh2
        },
        {
          id: 2,
          title: '亚商读书会第三期',
          time: '2016.06.27',
          text: '那十年 影响我们的一本书',
          imgUrl: dsh3
        },
        {
          id: 3,
          title: '亚商读书会第四期',
          time: '2016.08.18 ',
          text: '坚毅如山 平静如水',
          imgUrl: dsh4
        },
        {
          id: 4,
          title: '亚商读书会第五期',
          time: '2018.05.15 ',
          text: '真善美之间的逻辑关系',
          imgUrl: dsh5
        }
      ]
    }
  }
}
</script>

<style scoped>
.reading-party{
  min-width: 1200px;
}
.banner{
  width: 100%;
}
.reading-main{
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: 48px;
}
.reading-main .tit{
    height: 46px;
    line-height: 46px;
    font-size: 14px;
    text-align: left;
}
.reading-main .tit a{
    color: #333;
}
.reading-main .tit span{
    cursor: pointer;
}
.reading-main .arr-bold{
  font-weight: 600;
}
.reading-main .font-blue{
  color: #003B83;
}
.lead{
  border: 1px solid #CED7E2;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 50px;
}
.lead .logo{
  margin-right: 48px;
}
.lead p.text{
  color: #666;
  line-height: 22px;
  text-align: justify;
  text-indent: 2em;
}
.reding-list{
  background: #fff;
  padding: 34px 10px;
  border: 1px solid #ced7e2;
}
.reding-list ul{
  margin-bottom: 20px;
  padding-left: 10px;
  text-align: left;
}
.reding-list ul li{
  display: inline-block;
  width: 280px;
  height: 232px;
  cursor: pointer;
  margin-right: 12px;
}
.reding-list ul li:last-child{
  margin-right: 0;
}
.reding-list ul span{
  display: inline-block;
}
.reding-list ul .reading-pic{
  width: 100%;
  height: 182px;
  overflow: hidden;
  position: relative;
}
.reding-list .mask-title{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 38px;
  line-height: 38px;
  padding: 0 15px;
  box-sizing: border-box;
  color: #fff;
  background: rgba(0, 0, 0, 0.6);
  /* font-size: 14px; */
}
.reading-pic img{
  transition: all 0.8s;
  -webkit-transition: all 0.8s;
}
.reading-pic:hover img{
  transform: scale(1.1);
  -webkit-transform: scale(1.1);
  transition: all 0.8s;
  -webkit-transition: all 0.8s;
}
.reding-list .text{
  color: #666;
  text-align: left;
  width: 100%;
  height: 30px;
  line-height: 20px;
  padding: 10px 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.reading-main .more{
  color: #333;
  line-height: 40px;
  margin-top: 40px;
}
.reading-main .more span{
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/components/readingParty/ReadingParty.vue